module.exports = __webpack_public_path__ + "static/media/passport.767bd243.png";